// ComparisonTable.js
import React, { useState } from 'react';
import styles from './comparisonTable.module.css';
import { Close, Pdf, Leaf } from '../../../../Svg';
import { useDispatch } from 'react-redux';
import { deleteCompareproduct } from '../../../redux/productSlice';
import { useNavigate } from 'react-router-dom';
import { stripHtmlTags } from '../../../utils/utils';

const ComparisonTable = ({ data, removeId }) => {

    const navigate = useNavigate()
    const [expandedProducts, setExpandedProducts] = useState({});

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };


    if (!data || data.length === 0) return <p>No data available</p>;


    const getAllKeys = (field) => {
        const allKeys = new Set();
        data.forEach((product) => {
            if (product[field]) {
                Object.keys(product[field]).forEach((key) => allKeys.add(key));
            }
        });
        return Array.from(allKeys);
    };

    const attributeKeys = getAllKeys("attributes");
    // const environmentalKeys = getAllKeys("environmental");


    const isRowSame = (key, field) => {
        const values = data.map((product) => JSON.stringify(product[field]?.[key] || "N/A"));
        return values.every((val) => val === values[0]);
    };

    const isSame = (field, subfield) => {
        if (!data || data.length === 0) return false;

        let referenceValue = data[0]?.[field]?.[subfield];

        return data.every((product) => product?.[field]?.[subfield] === referenceValue);
    };



    return (
        <div
            className={styles.container}>
            <table
                className={styles.tablecontainer}
                style={{ borderCollapse: 'collapse' }}
            >
                <tbody>
                    <tr>
                        <td

                            className={styles.data}
                        >
                            Image
                        </td>
                        {data.map((product, index) => (
                            <td key={index} style={{ padding: "10px", border: "1px solid #ddd" }}>

                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img
                                        src={product?.assets?.featuredImage[0]}
                                        alt={`Product ${index + 1}`}
                                        style={{ padding: '18px 12px', height: 41, width: 41 }}
                                    />
                                    {data?.length > 2 ?
                                        <div onClick={() => removeId(product?._id)} style={{ cursor: 'pointer' }}>

                                            <Close />
                                        </div>
                                        : null}
                                </div>

                            </td>
                        ))}
                    </tr>
                    <tr style={{}}>
                        <td className={styles.data}>
                            Mfr Part #
                        </td>
                        {data.map((product, index) => (
                            <td key={index} style={{ color: '#4F49C8', fontWeight: 'bold', cursor: 'pointer', backgroundColor: isRowSame("productNumber", "productOverview") ? "#c3e6cb" : "transparent" }} className={styles.tableData} onClick={() => navigate(`/productCode/${product?.productOverview?.productNumber[0]}`)}>
                                {product?.productOverview?.productNumber[0] || "N/A"}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={styles.data}>
                            Supplier
                        </td>
                        {data.map((product, index) => (
                            <td key={index} className={styles.tableData} style={{ backgroundColor: isRowSame("manufacturer", "productOverview") ? "#c3e6cb" : "transparent" }}>
                                {product?.productOverview?.manufacturer[0]?.name || "N/A"}
                            </td>
                        ))}
                    </tr>
                    <tr >
                        <td className={styles.data}>
                            Catalog Description
                        </td>
                        {data.map((product, index) => (
                            <td key={index} className={styles.tableData} style={{ backgroundColor: isRowSame("description", "productOverview") ? "#c3e6cb" : "transparent" }}>
                                {stripHtmlTags(product?.productOverview?.description?.[0] || product?.description) || "N/A"}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={styles.data}>
                            Categories
                        </td>
                        {/* style={{ backgroundColor: isRowSame("categories", "categories") ? "#c3e6cb" : "transparent" }} */}
                        {data.map((product, index) => (
                            <td key={index} className={styles.tableData} >

                                {product?.categories?.map((i, index) => product?.categories?.length - 1 == index ? i?.name : i?.name + ',') || "N/A"}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={styles.data}>
                            Unit Price
                        </td>
                        {/* {data.map((product, index) => (
                            <td key={index} className={styles.tableData}   >
                                {product?.quantityTable?.map((up, index) => (
                                    <div key={index} className={styles.dataMargin}>
                                        {up?.breakQty}: <span style={{ color: '#222222', fontWeight: 700 }}>${up?.unitPrice}</span>
                                        <div>
                                            {up?.packaging}
                                        </div>
                                    </div>
                                ))
                                }
                            </td>
                        ))} */}
                        {data.map((product, index) => (
                            <td className={styles.tableData} >
                                {product?.quantityTable
                                    ?.slice(
                                        0,
                                        expandedProducts[product?._id]
                                            ? product?.quantityTable?.length
                                            : 2
                                    )
                                    .map((i, index) => (
                                        <div key={index} className={styles.dataMargin} style={{ marginTop: 5 }}>
                                            {i?.breakQty}: <span style={{ color: '#222222', fontWeight: 700 }}>₹{i?.unitPrice}</span>
                                            <div>
                                                {i?.packaging}
                                            </div>
                                        </div>
                                    ))}
                                {product?.quantityTable?.length > 2 && (
                                    <div

                                        onClick={(e) => {

                                            toggleShowAll(product?._id);
                                        }}
                                        style={{ color: '#4f49c8', cursor: 'pointer' }}
                                    >
                                        <div className={styles.dataColorChange}>
                                            {expandedProducts[product?._id]
                                                ? "Show Less"
                                                : "More Inventory"}
                                        </div>
                                    </div>
                                )}
                            </td>
                        ))
                        }
                    </tr>

                    <tr>
                        <td className={styles.data}>
                            Quantity Available
                        </td>
                        {data.map((product, index) => (
                            <td key={index} className={styles.tableData} style={{
                                backgroundColor:
                                    isSame("inventory", "qtyAvailable") &&
                                        isSame("inventory", "canShipImmediately")
                                        ? "#c3e6cb"
                                        : "transparent",
                            }} >
                                <div style={{ color: '#222222', fontWeight: 700 }}>
                                    {product?.inventory?.qtyAvailable || "N/A"}
                                </div>
                                <div>
                                    {product?.inventory?.canShipImmediately ? 'Immediate' : 'Not immediate'}
                                </div>
                            </td>
                        ))}
                    </tr>
                    {attributeKeys.map((key) => (
                        <tr key={key}>
                            <td
                                className={styles.data}
                            >
                                {key.toUpperCase()}
                            </td>
                            {data.map((product, index) => {
                                const value = product.attributes?.[key];
                                return (
                                    <td key={index} className={styles.tableData} style={{ backgroundColor: isRowSame(key, "attributes") ? "#c3e6cb" : "transparent" }}>
                                        {Array.isArray(value) ? value.join(", ") : value || "N/A"}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}


                    <tr>
                        <td className={styles.data}>
                            Supplier
                        </td>
                        {data.map((product, index) => (
                            <td className={styles.tableData} key={index}>
                                <Leaf />
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={styles.data}>
                            Supplier
                        </td>
                        {data.map((product, index) => (
                            <td className={styles.tableData} key={index}>
                                <a href={product?.productOverview?.datasheetUrl[0]} target='_blank'>
                                    <Pdf />
                                </a>
                            </td>
                        ))}

                    </tr>
                </tbody>
            </table>
        </div>


    );
};

export default ComparisonTable;
